import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  Avatar,
  Collapse
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import ProjectAvatar from "./ProjectAvatar";
import ActivityBar from "./ActivityBar";
import MemberDetailsTable from "./MemberDetailsTable";

const cellStyle = {
  padding: '10px 16px',
};

const MemberRow = ({ row, isSelected, onSelectToggle }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={{
        '&:hover': { boxShadow: open ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.1)' },
        boxShadow: open ? '0px 16px 20px rgba(0, 0, 0, 0.3)' : 'none',
        transition: 'box-shadow 0.3s ease',
      }}>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderLeft: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          minWidth: '32px',
          maxWidth: '32px',
          backgroundColor: '#fff',
          borderRadius: open ? '10px 0 0 0px' : '10px 0 0 10px',
        }}>
          <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          backgroundColor: '#fff',
        }}>
          {row.id}
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'left'
        }}>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            onClick={() => setOpen(!open)}
            sx={{ cursor: "pointer" }}
          >
            <Avatar src={row.avatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
            <Box>
              <Typography fontWeight="bold">{row.name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {row.role}
              </Typography>
            </Box>
          </Box>
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          <ProjectAvatar projects={row.projects} />
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          {row.time}
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          <ActivityBar activity={row.activity} />
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          -
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          {row.idle}%
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          color: '#626262',
          backgroundColor: '#fff',
          textAlign: 'center'
        }}>
          $0.00
        </TableCell>
        <TableCell sx={{
          ...cellStyle,
          border: 'none',
          borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          borderRight: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
          backgroundColor: '#fff',
          textAlign: 'center',
          borderRadius: open ? '0px 10px 0 0px' : '0px 10px 10px 0px',
        }}>
          <Typography color="primary" sx={{ cursor: "pointer" }}>
            {row.notes} Notes
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{
          paddingBottom: 0,
          paddingTop: 0,
          paddingLeft: "0",
          paddingRight: '0',
          border: 'none'
        }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <MemberDetailsTable details={row.details} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default MemberRow;